<template>
    <div>
        <div class="tabs-container">
            <!--<tab
                v-for="loh in chado" :key="loh.id"
                class-name="is-active"
                :class-condition="$route.params.child_id == loh.id"
                method="changeTab"
                :method-value="loh.id"
                :text="loh.name"
                @changeTab="changeTab"
            >
            </tab>-->asd
        </div>

        <router-view></router-view>
    </div>
</template>

<script>
    import env from '../../env'
    import Tab from '../../common_components/Tab'

    export default {
        data: () => ({
            env,
            chado: [
                {
                    name: 'vasiliy',
                    id: 1
                },
                {
                    name: 'katusha',
                    id: 2
                },
            ]
        }),
        components: {
            Tab
        },
        methods: {
            changeTab(id) {
                this.$router.push(`/payment/${id}/`);
            }
        }
    }
</script>

<style lang="sass" scoped>

</style>
